<template>
  <div class="step step_3"  :class="{'form__step_hidden': step != number}">
    <h3 class="form__title">{{prefix == 'client'? 'Ваши инициалы и пол':'Инициалы и пол созаемщика'}}</h3>
    <TextInput :errorcont="errorcont" v-model="stepsdata[number][names[0]]" :name="names[0]" :increased="!stepsdata[number][names[0]]" text="Фамилия*" :required="true"/>
    <TextInput :errorcont="errorcont" v-model="stepsdata[number][names[1]]" :name="names[1]" :increased="!stepsdata[number][names[1]]" text="Имя*" :required="true"/>
    <TextInput :errorcont="errorcont" v-model="stepsdata[number][names[2]]" :name="names[2]" :increased="!stepsdata[number][names[2]]" text="Отчество" :required="false"/>
    <DateInput :validation="isValidBirthdate" :errorcont="errorcont" v-model="stepsdata[number][names[3]]" :name="names[3]" :increased="!stepsdata[number][names[3]]" text="Дата рождения*" :required="true"/>
    <TextInput :errorcont="errorcont" v-model="stepsdata[number][names[4]]" :name="names[4]" :increased="!stepsdata[number][names[4]]" text="Место рождения*" :required="true"/>
    <RadioGroup v-model="stepsdata[number][names[5]]" :name="names[5]" title="Пол" :required="true" :grid="true" :gridstay="true" :values="['Мужской','Женский']"/>
    <h3 class="form__title">Адрес регистрации/местонахождения</h3>
    <TextInput :customError="(!city || client.address.city_kladr_id)? '' : 'Выберите значение из списка'" :options="cityoptions" :errorcont="errorcont" v-model="stepsdata[number][names[6]]" :name="names[6]" :increased="!stepsdata[number][names[6]]" text="Город / Населенный пункт*" :required="true"/>
    <ShortFields align="flex-end">
      <TextInput :disabled="nostreet" :customError="(!street || client.address.street_kladr_id || nostreet)? '' : 'Выберите значение из списка'" :options="streetoptions" :errorcont="errorcont" v-model="stepsdata[number][names[7]]" :name="names[7]" :increased="!stepsdata[number][names[7]]" text="Улица*" :required="!nostreet"/>
      <CheckboxInput @input="()=>nullifyStreetData()" v-model="stepsdata[number][names[21]]" :name="names[21]" descr="Нет улицы" />
    </ShortFields>
    <ShortFields>
      <TextInput :customError="(!house || client.address.house_kladr_id || nostreet)? '' : 'Выберите значение из списка'" :options="houseoptions" :errorcont="errorcont" v-model="stepsdata[number][names[8]]" :name="names[8]" :increased="!stepsdata[number][names[8]]" text="Дом*" :required="true"/>
      <TextInput :errorcont="errorcont" v-model="stepsdata[number][names[9]]" :name="names[9]" :increased="!stepsdata[number][names[9]]" text="Квартира" :required="false"/>
    </ShortFields>
    <TextInput @input.native="enableManualIndexInput($event, 19)" :errorcont="errorcont" v-model="stepsdata[number][names[19]]" :name="names[19]" :increased="!stepsdata[number][names[19]]" text="Почтовый индекс*" :required="true"/>
    <RadioGroup v-model="stepsdata[number][names[10]]" :name="names[10]" title="Адрес фактического проживания / для почтовой корреспонденции совпадает с адресом регистрации?" :required="true" :grid="true" :gridstay="true" :values="['Да','Нет']"/>
    <transition-group ref="switchwrap" :style="{'height': !additionalFieldsEnabled ? '0px !important': ''}" tag="div" name="fade" class="switchwrap" :key="100">
      <TextInput :customError="(!realcity || client.realaddress.city_kladr_id)? '' : 'Выберите значение из списка'"  :key="1" v-show="additionalFieldsEnabled"  :options="realcityoptions" :errorcont="errorcont" v-model="stepsdata[number][names[11]]" :name="names[11]" :increased="!stepsdata[number][names[11]]" text="Город / Населенный пункт*" :required="true"/>
      <ShortFields align="flex-end" :key="2" v-show="additionalFieldsEnabled">
        <TextInput :disabled="norealstreet" :customError="(!realstreet || client.realaddress.street_kladr_id || norealstreet)? '' : 'Выберите значение из списка'" :options="realstreetoptions" :errorcont="errorcont" v-model="stepsdata[number][names[12]]" :name="names[12]" :increased="!stepsdata[number][names[12]]" text="Улица*" :required="!norealstreet"/>
        <CheckboxInput @input="()=>nullifyStreetData('real')" v-model="stepsdata[number][names[22]]" :name="names[22]" descr="Нет улицы" />
      </ShortFields>
      <ShortFields  :key="3" v-show="additionalFieldsEnabled">
        <TextInput :customError="(!realhouse || client.realaddress.house_kladr_id || norealstreet)? '' : 'Выберите значение из списка'" :options="realhouseoptions" :errorcont="errorcont" v-model="stepsdata[number][names[13]]" :name="names[13]" :increased="!stepsdata[number][names[13]]" text="Дом*" :required="true"/>
        <TextInput :errorcont="errorcont" v-model="stepsdata[number][names[14]]" :name="names[14]" :increased="!stepsdata[number][names[14]]" text="Квартира" :required="false"/>
      </ShortFields>
      <TextInput v-show="additionalFieldsEnabled" :key="4" @input.native="enableManualIndexInput($event, 20)" :errorcont="errorcont" v-model="stepsdata[number][names[20]]" :name="names[20]" :increased="!stepsdata[number][names[20]]" text="Почтовый индекс*" :required="true"/>
    </transition-group>
    <h3 class="form__title">Контактные номера , адрес электронной почты</h3>
    <NumberInput :filled="(v)=>v.length==18" mask='+7 (###) ###-##-##' :errorcont="errorcont" v-model="stepsdata[number][names[15]]" :name="names[15]" :increased="!stepsdata[number][names[15]]" text="Мобильный телефон*" :required="true"/>
    <TextInput :errorcont="errorcont" v-model="stepsdata[number][names[16]]" :name="names[16]" :increased="!stepsdata[number][names[16]]" text="Домашний телефон" />
    <NumberInput :validation="(v)=>(v.length == 18 || !v)?'':'Заполните или сотрите поле'" :filled="(v)=>v.length==18" mask='+7 (###) ###-##-##' :errorcont="errorcont" v-model="stepsdata[number][names[17]]" :name="names[17]" :increased="!stepsdata[number][names[17]]" text="Служебный телефон"/>
    <TextInput :validation="isValidEmail" :errorcont="errorcont" v-model="stepsdata[number][names[18]]" :name="names[18]" :increased="!stepsdata[number][names[18]]" text="Электронная почта*" :required="true"/>

    <div class="form__btns">
      <Btn class="btn_gray" @click.native.prevent="$store.commit('prevStep')">Назад</Btn>
      <Btn @click.native.prevent="$store.commit('nextStep')" :disabled="!filled || step != number">Далее</Btn>
    </div>
  </div>
</template>

<script>
import Btn from './ui/Btn.vue'
import TextInput from '@/components/TextInput.vue'
import RadioGroup from './RadioGroup.vue'
import { mapState } from 'vuex'
import ShortFields from './ShortFields.vue'
import DateInput from './DateInput.vue'
import NumberInput from './NumberInput.vue'
import isValidBirthDate from '../mixins/isValidBirthDate.vue'
import DaDataAddress from '../mixins/DaDataAddress.vue'
import smoothReflow from 'vue-smooth-reflow'
import isValidEmail from '../mixins/isValidEmail.vue'
import CheckboxInput from './CheckboxInput.vue'

export default {
  props: {
    number: {type: Number, default: 3},
    prefix: {type: String, default: 'client'}
  },  
  components: { Btn, TextInput, RadioGroup, ShortFields, DateInput, NumberInput, CheckboxInput },
  data: (instance)=>({
    refreshKey: 0,
    names: [`${instance.prefix}surname`,`${instance.prefix}name`,`${instance.prefix}patronymic`,`${instance.prefix}birthdate`,`${instance.prefix}place_of_birth`,`${instance.prefix}sex`,`${instance.prefix}city`,`${instance.prefix}street`,`${instance.prefix}house`,`${instance.prefix}flat`,`${instance.prefix}realaddressquestion`,`${instance.prefix}realcity`,`${instance.prefix}realstreet`,`${instance.prefix}realhouse`,`${instance.prefix}realflat`,`${instance.prefix}mobphone`,`${instance.prefix}homephone`,`${instance.prefix}workphone`,`${instance.prefix}mail`, `${instance.prefix}index`, `${instance.prefix}realindex`, `no_${instance.prefix}_street`, `no_${instance.prefix}_realstreet`],
    errorcont: {},
    manualIndexInput: {
      19: false, //names[19] - clientindex
      20: false  //names[20] - clientrealindex
    }
  }),
  mixins: [isValidBirthDate, isValidEmail, DaDataAddress,smoothReflow],
  mounted(){
    this.$smoothReflow({
      el: this.$refs.switchwrap.$el,
      transition: 'height .5s'
    })
  },
  methods: {
    nullifyStreetData(real) {
      let fields = {
        streetindex: real? 12: 7,
        houseindex: real? 13: 8,
        flatindex: real? 14: 9,
        indexindex: real? 20: 19
      }
      for (let index of Object.values(fields))
        this.$set(this.stepsdata[this.number],this.names[index], '')
      this.nullifyStreetDaData(real)
    },
    enableManualIndexInput(event, i) {
      if (!event.isTrusted) return
      this.manualIndexInput[i] = true
      this.refreshKey++
    }
  },
  computed: {
    ...mapState(['stepsdata','step']),
    nostreet(){
      return this.stepsdata[this.number][this.names[21]]
    },
    norealstreet(){
      return this.stepsdata[this.number][this.names[22]]
    },
    additionalFieldsEnabled(){
      return this.stepsdata[this.number][this.names[10]] == 'Нет'
    },
    filled(){
      this.refreshKey
      const notrequired=[2,9,14,16,17,21,22]
      if (this.nostreet)
        notrequired.push(7)
      if (this.norealstreet)
        notrequired.push(12)
      for (let [i, name] of this.names.entries()) {
        if (((i >= 11 && i <= 14) || (i == 20))  && !this.additionalFieldsEnabled)
          continue
        if ((!this.stepsdata[this.number][name] && !notrequired.includes(i)) || this.errorcont[name])
          return false
      }
      return  true
    },
    city:{
      get(){
        return this.stepsdata[this.number][this.names[6]]
      },
      cache: false
    },
    street:{
      get(){
        return this.stepsdata[this.number][this.names[7]]
      },
      cache: false
    },
    house:{
      get(){
        return this.stepsdata[this.number][this.names[8]]
      },
      cache: false
    },    
    realcity:{
      get(){
        return this.stepsdata[this.number][this.names[11]]
      },
      cache: false
    },
    realstreet:{
      get(){
        return this.stepsdata[this.number][this.names[12]]
      },
      cache: false
    },
    realhouse:{
      get(){
        return this.stepsdata[this.number][this.names[13]]
      },
      cache: false
    },    
  },
  watch:{
    async city(val){
      this.cityoptions = await this.citySuggest(val)
    },
    async street(val){
      this.streetoptions = await this.streetSuggest(val)
    },
    async house(val){
      this.houseoptions = await this.houseSuggest(val, false, this.nostreet)
    },
    async realcity(val){
      this.realcityoptions = await this.citySuggest(val, true)
    },
    async realstreet(val){
      this.realstreetoptions = await this.streetSuggest(val, true)
    },
    async realhouse(val){
      this.realhouseoptions = await this.houseSuggest(val, true, this.norealstreet)
    },
    'client.address.index'(val) {
      if (val && !this.manualIndexInput[19]) 
        this.stepsdata[this.number][this.names[19]] = val
    },
    'client.realaddress.index'(val) {
      if (val && !this.manualIndexInput[20]) 
        this.stepsdata[this.number][this.names[20]] = val
    },
  }
}
</script>

<style lang="sass">

</style>